import { MyProfile } from 'components/MyProfile';

const ScreenMyProfile = () => <MyProfile />;

export default ScreenMyProfile;
